import { render } from "./vision-mission.vue?vue&type=template&id=0fd79b82"
import script from "./vision-mission.vue?vue&type=script&lang=js"
export * from "./vision-mission.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__